<template>
  <div class="login-component">
    <WovenBrand
      title="Quick |digital payments| for the digital business."
      description="Woven provides a new type of payment account. Built for businesses that need a faster, easier and more reliable way to move money."
      no-step
    />
    <div class="login-component__login">
      <Logo classes="mobile-logo" />
      <Help />
      <div class="form">
        <FormHeader
          title="Login"
          description="Welcome! Kindly login to continue moving your money through a fast, easy and reliable means. "
        />
        <form v-on:submit.prevent="login" class="input-group" action="">
          <InputV2
            placeholder="Email Address"
            type="email"
            :required="true"
            v-model="email"
          />
          <InputV2
            placeholder="Password"
            type="password"
            :required="true"
            v-model="password"
          />
          <div class="flex-end">
            <router-link to="/password-reset" class="reset-password"
              >Reset Password?</router-link
            >
          </div>
          <Button
            buttonName="Login"
            classes="woven-color"
            buttonType="submit"
            :disabled="disabled"
            :onClick="() => {}"
          >
          </Button>
          <div class="register">
            Don’t have an account?
            <router-link to="/register">Create an account</router-link>
          </div>
        </form>
      </div>
      <BackgroundImage classes="mobile-background-image" />
      <WovenStrip :loading="disabled" />
    </div>
  </div>
</template> 

<script>
import WovenBrand from "@/components/wovenbrand.vue";
import FormHeader from "@/components/formheader.vue";
import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import WovenStrip from "@/components/wovenstrip.vue";
import Help from "@/components/help.vue";
import Logo from "@/components/logo";
import BackgroundImage from "@/components/backgroundlogo";
export default {
  name: "Login",
  metaInfo: {
    title: "Login",
  },
  components: {
    WovenBrand,
    FormHeader,
    InputV2,
    Button,
    WovenStrip,
    Help,
    Logo,
    BackgroundImage
  },
  data() {
    return {
      email: "",
      password: "",
      disabled: false,
      error: false,
    };
  },
  methods: {
    login() {
      this.disabled = true;
      if (this.email !== "" && this.password !== "") {
        console.log("ben1");
        let requestObject = {
          email: this.email.trim(),
          password: this.password.trim(),
        };
        this.$store
          .dispatch("login", requestObject)
          .then((response) => {
            console.log("ben2");
            this.$router.push({ name: "overview" });
            
            this.disabled = false;
          })
          .catch((error) => {
            console.log("ben3");
            if (error.response && error.response.status === 401) {
    this.$store.dispatch("logout"); // Clear stored token
    this.$router.push({ name: "login" }); // Redirect to login page
    this.$notify({
      group: "notifications-default",
      type: "error text-white",
      title: "Session Expired",
      text: "Your session has expired. Please log in again.",
    });
  } else {
    // Handle other errors
    this.$notify({
      group: "notifications-default",
      type: "error text-white",
      title: "Error",
      text: error.body.message || "An unexpected error occurred.",
    });
  }
            this.error = true;
            this.disabled = false;
          });
      } else {
        if (this.email.value == "") {
          console.log("ben4");
          this.email.empty = true;
        }
        if (this.password.value == "") {
          console.log("ben5");
          this.password.empty = true;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.login-component {
  background: #fff;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  &__login {
    flex: 0.8;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    height: 100vh;
    &__help {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      color: #616e7c;
      position: absolute;
      top: 64px;
      right: 64px;
      span {
        color: #000;
        text-decoration: underline;
      }
    }
    .form {
      max-width: 465px;
      button {
        width: 100%;
        height: 48px;
        margin-top: 24px;
        margin-bottom: 16px;
      }
      .register {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #616e7c;
        a {
          color: #000;
          text-decoration: underline;
        }
      }
      .terms-condition {
        display: flex;
        align-items: center;
        svg {
          margin-right: 10px;
        }
        p {
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
          color: #616e7c;
        }
      }
    }
    .input-group {
      padding-top: 30px;
    }
  }
  .input-v2 {
    input {
      margin-bottom: 20px;
    }
  }
  .flex-end {
    display: flex;
    justify-content: flex-end;
  }
  .reset-password {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: right;
    color: #e00b5b;
    cursor: pointer;
  }
  .btn {
    svg {
      width: 20px;
      height: 20px;
    }
  }
  .woven-brand {
    flex: 0.2;
    height: 100vh;
    padding: 64px;
    max-width: 430px;
    min-width: 350px;
    &__description {
      padding-top: 32px;
    }
  }
  .mobile-logo {
    display: none;
  }
  .mobile-background-image {
    display: none;
  }
  @media screen and (max-width: 880px) {
    .mobile-background-image {
      display: block;
    }
    .woven-brand {
      display: none
    }
    .mobile-logo {
      display: block;
      position: absolute;
      top: 40px;
      left: 5%;
    }
    .help-component {
      top: 50px;
      right: 5%;
    }
    &__login {
      flex: 1;
      padding: 5%;
      .form {
        height: 60vh;
      }
    }
  }
}
</style>